import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import dispatcher from 'mewe/dispatcher';
import PS from 'mewe/utils/pubsub';

export default class SidebarLeftChat extends Component {
  @service router;

  @action
  createNewChat() {
    dispatcher.dispatch('chat', 'createNewChat');
    PS.Pub('sidebar.action.mobile');
  }

  @action
  closeChatRequests() {
    dispatcher.dispatch('app', 'showDYKpopup', 'chatRequest');
    this.router.transitionTo('app.chat');
  }

  @action
  toggleChatRequests() {
    dispatcher.dispatch('chat', 'showToggleChatRequestsPrompt');
  }
}
